import {AxiosRequestConfig} from 'axios';
import {useInfiniteQuery} from 'react-query';
import request from '../../axios';

const BUYERS_LIST_INFINITE_KEY = 'get-buyers-list-infinite';

const useGetBuyersListInfinite = (payload: IBuyerParams) => {
  return useInfiniteQuery(
    [BUYERS_LIST_INFINITE_KEY, payload],
    ({pageParam = 1}) => fetcher(pageParam, payload),
    {
      getNextPageParam: lastPage => {
        const nextPageUrl = lastPage?.next;
        if (!nextPageUrl) return undefined;

        const nextPage = new URL(nextPageUrl).searchParams.get('page');
        return nextPage ? Number(nextPage) : undefined;
      },
    },
  );
};

export default useGetBuyersListInfinite;

// ------------------------------------------------------------------
//* Exclusive fetcher function to this infinite query
// ------------------------------------------------------------------

const fetcher = async (
  page: number,
  payload: IBuyerParams,
): Promise<IBuyersList> => {
  const {data} = await request.get(
    'api/v2/wanted/supplier-shop-requirements-list',
    {
      params: {
        ...payload,
        page,
      },
    } as AxiosRequestConfig,
  );
  return data as IBuyersList;
};
